import React, { Component } from "react";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import moment from "moment";
import {
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableSortLabel,
  Button,
  TablePagination,
  Select,
  MenuItem,
  InputLabel,
  Box,
  Chip,
} from "@material-ui/core";

import { userService } from "_services/user.service";
import enMsg from "__helpers/locale/en/en";

import { apiPath } from "api";
import { generalAuthTokenHeader } from "__helpers/auth-header";

import { connect } from "react-redux";
import { reduxLoad } from "js/actions/index";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {
  PER_PAGE_OPTIONS,
  DEFAULT_PER_PAGE_RECORDS,
} from "__helpers/constants";

function mapDispatchToProps(dispatch) {
  return {
    reduxLoad: (reduxLoadVal) => dispatch(reduxLoad(reduxLoadVal)),
  };
}
const mapStateToProps = (state) => {
  return {
    userInfoRedux: state.userInfo,
    timestampRedux: state.timestamp,
    reduxLoadFlag: state.reduxLoadFlag,
  };
};

const headCells = [
  { id: "providerName", numeric: false, sorting: true, label: "Provider Name" },
  { id: "accountStatus", numeric: false, sorting: true, label: "Account Status" },
  { id: "registered", numeric: false, sorting: true, label: "Registered" },
  { id: "email", numeric: false, sorting: false, label: "Email" },
  { id: "phone", numeric: false, sorting: false, label: "Phone" },
  { id: "linkedFacilities", numeric: false, sorting: false, label: "Linked Facilities" },
  { id: "lastLoginDate", numeric: false, sorting: true, label: "Last Login (Any User)" },
  { id: "lastLoginBy", numeric: false, sorting: false, label: "Last Login By" },
  { id: "daysSinceLastLogin", numeric: true, sorting: true, label: "Days Since Login" },
  { id: "totalReferrals", numeric: true, sorting: true, label: "Total Referrals" },
  { id: "acknowledged", numeric: true, sorting: true, label: "Acknowledged" },
  { id: "finalized", numeric: true, sorting: true, label: "Finalized" },
  { id: "declined", numeric: true, sorting: true, label: "Declined" },
  { id: "dropped", numeric: true, sorting: true, label: "Dropped" },
  { id: "pendingAwaiting", numeric: true, sorting: true, label: "Pending/Awaiting" },
  { id: "avgResponseTimeHours", numeric: true, sorting: true, label: "Avg Response Time (hrs)" },
  { id: "responseRate", numeric: true, sorting: true, label: "Response Rate %" },
  { id: "responseRateTrend", numeric: false, sorting: true, label: "Trend" },
  { id: "engagementStatus", numeric: false, sorting: true, label: "Engagement Status" },
];

const ACCOUNT_STATUSES = [
  "New",
  "Inactive",
  "Non-Charge",
  "Charge-Paid",
  "Charge-Unpaid",
];
const ENGAGEMENT_STATUSES = [
  "Active",
  "Low Response",
  "Non-Responsive",
  "Never Logged In",
];

const engagementColors = {
  Active: { backgroundColor: "#4caf50", color: "#fff" },
  "Low Response": { backgroundColor: "#ff9800", color: "#fff" },
  "Non-Responsive": { backgroundColor: "#f44336", color: "#fff" },
  "Never Logged In": { backgroundColor: "#9e9e9e", color: "#fff" },
};

const trendColors = {
  Improving: "#4caf50",
  Declining: "#f44336",
  Stable: "#757575",
  New: "#757575",
};

class ProviderEngagementReportClass extends Component {
  constructor(props) {
    super(props);
    this.dateUtility = new DateFnsUtils();
    this.state = {
      loading: false,
      startDate: null,
      endDate: null,
      startDateValid: false,
      endDateValid: false,
      startMaxDate: new Date(),
      facilityList: [],
      facilities: [],
      accountStatusFilter: "",
      engagementStatusFilter: "",
      reportData: null,
      displayData: [],
      orderBy: "providerName",
      direction: true,
      perPage: DEFAULT_PER_PAGE_RECORDS,
      currentPage: 0,
    };
  }

  componentDidMount() {
    fetch(apiPath.getActiveFacilities, {
      method: "GET",
      headers: generalAuthTokenHeader(),
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({ facilities: data });
      })
      .catch((error) => {
        console.error("Error fetching facilities:", error);
      });
  }

  handleStartDateChange = (date) => {
    const { endDate } = this.state;
    this.setState({ startDate: date, startDateValid: true });
    if (endDate && date > endDate) {
      this.setState({ endDate: null, endDateValid: false });
    }
  };

  handleEndDateChange = (date) => {
    this.setState({ endDate: date, endDateValid: true });
  };

  handleChangeFilter = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value }, () => {
      if (this.state.reportData) {
        this.applyClientFilters();
      }
    });
  };

  handleChangeFacilityList = (event) => {
    let value = event.target.value;
    value = value.filter((v) => v !== "");
    this.setState({ facilityList: value });
  };

  applyClientFilters = () => {
    if (!this.state.reportData || !this.state.reportData.providers) return;

    let filtered = [...this.state.reportData.providers];

    if (this.state.accountStatusFilter) {
      filtered = filtered.filter(
        (p) => p.accountStatus === this.state.accountStatusFilter
      );
    }
    if (this.state.engagementStatusFilter) {
      filtered = filtered.filter(
        (p) => p.engagementStatus === this.state.engagementStatusFilter
      );
    }

    const sorted = this.clientSideSort(
      filtered,
      this.state.orderBy,
      this.state.direction
    );
    this.setState({ displayData: sorted, currentPage: 0 });
  };

  clientSideSort = (data, orderBy, ascending) => {
    return [...data].sort((a, b) => {
      let valA = a[orderBy];
      let valB = b[orderBy];
      if (valA == null && valB == null) return 0;
      if (valA == null) return 1;
      if (valB == null) return -1;
      if (typeof valA === "boolean") {
        valA = valA ? 1 : 0;
        valB = valB ? 1 : 0;
      }
      if (typeof valA === "string") {
        return ascending
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      }
      return ascending ? valA - valB : valB - valA;
    });
  };

  tableSortHandler = (property) => () => {
    this.setState(
      (prevState) => ({
        orderBy: property,
        direction: prevState.orderBy === property ? !prevState.direction : true,
      }),
      () => {
        const sorted = this.clientSideSort(
          this.state.displayData,
          this.state.orderBy,
          this.state.direction
        );
        this.setState({ displayData: sorted });
      }
    );
  };

  handleChangePage = (event, newPage) => {
    this.setState({ currentPage: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({
      perPage: parseInt(event.target.value),
      currentPage: 0,
    });
  };

  handleGenerateReport = async () => {
    const { startDate, endDate, facilityList } = this.state;

    if (!startDate || !endDate) {
      let showNotification = {
        title: "Provider Engagement Report",
        message: "Please select both start and end dates.",
        type: "danger",
      };
      userService.showNotification(showNotification);
      return;
    }

    this.setState({ loading: true });
    let showNotification = {
      title: "Provider Engagement Report",
      message: "Generating report, please wait...",
      type: "info",
    };
    userService.showNotification(showNotification);

    try {
      const queryParams = [];
      if (startDate) {
        queryParams.push(`startDate=${moment(startDate).format("YYYY-MM-DD")}`);
      }
      if (endDate) {
        queryParams.push(`endDate=${moment(endDate).format("YYYY-MM-DD")}`);
      }
      facilityList.forEach((id) => {
        queryParams.push(`facilityIds=${id}`);
      });

      const url = `${apiPath.providerEngagementReport}?${queryParams.join("&")}`;

      const response = await fetch(url, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });

      if (!response.ok) {
        throw new Error("Failed to generate report");
      }

      const data = await response.json();

      this.setState(
        {
          reportData: data,
          loading: false,
        },
        () => {
          this.applyClientFilters();
          showNotification = {
            title: "Provider Engagement Report",
            message: `Report generated with ${data.totalProviders} providers.`,
            type: "success",
          };
          userService.showNotification(showNotification);
        }
      );
    } catch (error) {
      console.error("Error generating report:", error);
      this.setState({ loading: false });
      showNotification = {
        title: "Provider Engagement Report",
        message: "Failed to generate report. Please try again.",
        type: "danger",
      };
      userService.showNotification(showNotification);
    }
  };

  handleDownloadExcel = async () => {
    const { startDate, endDate, facilityList } = this.state;

    let showNotification = {
      title: "Provider Engagement Report",
      message: "Downloading Excel, please wait...",
      type: "info",
    };
    userService.showNotification(showNotification);

    try {
      const queryParams = [];
      if (startDate) {
        queryParams.push(`startDate=${moment(startDate).format("YYYY-MM-DD")}`);
      }
      if (endDate) {
        queryParams.push(`endDate=${moment(endDate).format("YYYY-MM-DD")}`);
      }
      facilityList.forEach((id) => {
        queryParams.push(`facilityIds=${id}`);
      });

      const url = `${apiPath.providerEngagementReportDownload}?${queryParams.join("&")}`;
      await userService.fetchsReferralReportData(url);
    } catch (error) {
      console.error("Error downloading report:", error);
      showNotification = {
        title: "Provider Engagement Report",
        message: "Failed to download Excel report.",
        type: "danger",
      };
      userService.showNotification(showNotification);
    }
  };

  renderSummaryCards() {
    const { reportData } = this.state;
    if (!reportData) return null;

    const cards = [
      {
        label: "Total Providers",
        value: reportData.totalProviders || 0,
        color: "info",
      },
      {
        label: "Active Providers",
        value: reportData.activeProviders || 0,
        color: "success",
      },
      {
        label: "Non-Responsive",
        value: reportData.nonResponsiveProviders || 0,
        color: "danger",
      },
      {
        label: "Never Logged In",
        value: reportData.neverLoggedInProviders || 0,
        color: "warning",
      },
      {
        label: "Avg Response Rate",
        value:
          reportData.avgResponseRate != null
            ? reportData.avgResponseRate.toFixed(1) + "%"
            : "0%",
        color: "info",
      },
    ];

    return (
      <Box display="flex" flexWrap="wrap" style={{ marginBottom: 16, gap: 16 }}>
        {cards.map((card, idx) => (
          <Card
            key={idx}
            style={{
              flex: "1 1 180px",
              minWidth: 180,
              margin: 0,
            }}
          >
            <CardHeader color={card.color} stats>
              <p style={{ fontSize: 14, margin: 0, color: "#fff" }}>
                {card.label}
              </p>
              <h3
                style={{
                  fontSize: 28,
                  fontWeight: "bold",
                  margin: "8px 0 0",
                  color: "#fff",
                }}
              >
                {card.value}
              </h3>
            </CardHeader>
          </Card>
        ))}
      </Box>
    );
  }

  render() {
    const {
      startDate,
      endDate,
      startMaxDate,
      facilities,
      facilityList,
      accountStatusFilter,
      engagementStatusFilter,
      displayData,
      orderBy,
      direction,
      perPage,
      currentPage,
      reportData,
      loading,
    } = this.state;

    const paginatedData = displayData.slice(
      currentPage * perPage,
      currentPage * perPage + perPage
    );

    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            {this.renderSummaryCards()}

            <Card>
              <CardHeader color="success" className="cusCardTitle">
                <h4 className="cusCardTitleText">
                  Provider Engagement Report
                </h4>
              </CardHeader>
              <CardBody>
                {/* Filters Row */}
                <Box
                  display="flex"
                  flexWrap="wrap"
                  alignItems="flex-end"
                  style={{ gap: 16, marginBottom: 16 }}
                >
                  <Box style={{ minWidth: 160 }}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        label="Start Date *"
                        format="MM/dd/yyyy"
                        margin="normal"
                        id="start-date-picker"
                        name="startDate"
                        value={startDate}
                        maxDate={startMaxDate}
                        onChange={this.handleStartDateChange}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                          className: "date-picker-span",
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </Box>

                  <Box style={{ minWidth: 160 }}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        label="End Date *"
                        format="MM/dd/yyyy"
                        margin="normal"
                        id="end-date-picker"
                        value={endDate}
                        maxDate={startMaxDate}
                        minDate={startDate}
                        onChange={this.handleEndDateChange}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                          className: "date-picker-span",
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </Box>

                  <Box style={{ minWidth: 200 }}>
                    <InputLabel htmlFor="facility-select">
                      Facilities
                    </InputLabel>
                    <Select
                      onChange={this.handleChangeFacilityList}
                      inputProps={{ name: "facilityList" }}
                      value={facilityList.length ? facilityList : [""]}
                      multiple
                      style={{ minWidth: 200 }}
                      MenuProps={{
                        PaperProps: {
                          style: { maxHeight: 48 * 4.5 + 8, width: 250 },
                        },
                        variant: "menu",
                        getContentAnchorEl: null,
                      }}
                    >
                      <MenuItem value="">All Facilities</MenuItem>
                      {facilities.length ? (
                        facilities.map((facility) => (
                          <MenuItem
                            key={facility.facilityId}
                            value={facility.facilityId}
                          >
                            {facility.facility_name}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value=" ">Not Available</MenuItem>
                      )}
                    </Select>
                  </Box>

                  <Box style={{ minWidth: 160 }}>
                    <InputLabel htmlFor="account-status-select">
                      Account Status
                    </InputLabel>
                    <Select
                      name="accountStatusFilter"
                      value={accountStatusFilter}
                      onChange={this.handleChangeFilter}
                      style={{ minWidth: 160 }}
                      displayEmpty
                    >
                      <MenuItem value="">All</MenuItem>
                      {ACCOUNT_STATUSES.map((status) => (
                        <MenuItem key={status} value={status}>
                          {status}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>

                  <Box style={{ minWidth: 160 }}>
                    <InputLabel htmlFor="engagement-status-select">
                      Engagement Status
                    </InputLabel>
                    <Select
                      name="engagementStatusFilter"
                      value={engagementStatusFilter}
                      onChange={this.handleChangeFilter}
                      style={{ minWidth: 160 }}
                      displayEmpty
                    >
                      <MenuItem value="">All</MenuItem>
                      {ENGAGEMENT_STATUSES.map((status) => (
                        <MenuItem key={status} value={status}>
                          {status}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                </Box>

                {/* Action Buttons */}
                <Box style={{ marginBottom: 16 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.handleGenerateReport}
                    disabled={!startDate || !endDate || loading}
                  >
                    {loading ? "Generating..." : "Generate Report"}
                  </Button>
                  <Button
                    variant="contained"
                    onClick={this.handleDownloadExcel}
                    disabled={!reportData}
                    style={{ marginLeft: 10, backgroundColor: "#4caf50", color: "#fff" }}
                  >
                    Download Excel
                  </Button>
                </Box>

                {/* Data Table */}
                <div style={{ overflowX: "auto" }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        {headCells.map((headCell) => (
                          <TableCell
                            key={headCell.id}
                            align={headCell.numeric ? "right" : "left"}
                            style={{ whiteSpace: "nowrap", fontWeight: "bold" }}
                          >
                            {headCell.sorting ? (
                              <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={direction ? "asc" : "desc"}
                                onClick={this.tableSortHandler(headCell.id)}
                              >
                                {headCell.label}
                              </TableSortLabel>
                            ) : (
                              headCell.label
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {paginatedData.length ? (
                        paginatedData.map((row) => (
                          <TableRow key={row.providerId}>
                            <TableCell>{row.providerName}</TableCell>
                            <TableCell>{row.accountStatus}</TableCell>
                            <TableCell>
                              {row.registered ? "Yes" : "No"}
                            </TableCell>
                            <TableCell>{row.email}</TableCell>
                            <TableCell>{row.phone}</TableCell>
                            <TableCell
                              style={{
                                maxWidth: 200,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                              title={row.linkedFacilities}
                            >
                              {row.linkedFacilities}
                            </TableCell>
                            <TableCell style={{ whiteSpace: "nowrap" }}>
                              {row.lastLoginDate
                                ? moment(row.lastLoginDate).format(
                                    "MM/DD/YYYY HH:mm"
                                  )
                                : "Never"}
                            </TableCell>
                            <TableCell>{row.lastLoginBy || "--"}</TableCell>
                            <TableCell align="right">
                              {row.daysSinceLastLogin != null
                                ? row.daysSinceLastLogin
                                : "--"}
                            </TableCell>
                            <TableCell align="right">
                              {row.totalReferrals || 0}
                            </TableCell>
                            <TableCell align="right">
                              {row.acknowledged || 0}
                            </TableCell>
                            <TableCell align="right">
                              {row.finalized || 0}
                            </TableCell>
                            <TableCell align="right">
                              {row.declined || 0}
                            </TableCell>
                            <TableCell align="right">
                              {row.dropped || 0}
                            </TableCell>
                            <TableCell align="right">
                              {row.pendingAwaiting || 0}
                            </TableCell>
                            <TableCell align="right">
                              {row.avgResponseTimeHours != null
                                ? row.avgResponseTimeHours.toFixed(1)
                                : "N/A"}
                            </TableCell>
                            <TableCell align="right">
                              {row.responseRate != null
                                ? row.responseRate.toFixed(1) + "%"
                                : "0%"}
                            </TableCell>
                            <TableCell>
                              <span
                                style={{
                                  color:
                                    trendColors[row.responseRateTrend] ||
                                    "#757575",
                                  fontWeight: "bold",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {row.responseRateTrend === "Improving" && "\u2191 "}
                                {row.responseRateTrend === "Declining" && "\u2193 "}
                                {row.responseRateTrend}
                              </span>
                            </TableCell>
                            <TableCell>
                              <Chip
                                label={row.engagementStatus}
                                size="small"
                                style={
                                  engagementColors[row.engagementStatus] || {}
                                }
                              />
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={headCells.length} align="center">
                            <div className="not-found-text">
                              {reportData
                                ? "No data available for the selected criteria."
                                : "Select date range and click Generate Report."}
                            </div>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </div>

                {displayData.length > 0 && (
                  <TablePagination
                    rowsPerPageOptions={PER_PAGE_OPTIONS}
                    component="div"
                    count={displayData.length}
                    rowsPerPage={perPage}
                    page={currentPage}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                  />
                )}
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export const ProviderEngagementReport = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProviderEngagementReportClass);

export default ProviderEngagementReport;
